__turbopack_context__.v({
  "notification": "notifications-module-scss-module__qHZgUa__notification",
  "notifications": "notifications-module-scss-module__qHZgUa__notifications",
});
